import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { getBaseUrlFromLocale } from 'src/utils/AppRoute';
import { ErrorPage } from './ErrorPage';

const NotFoundPage: React.FC<WithTranslation> = ({ t, i18n }) => {
  const homepage = getBaseUrlFromLocale(i18n.language) || '/';
  const title = t('page-not-found-title');
  const blurb = t('page-not-found-blurb', { homepage });

  return (
    <ErrorPage
      title={title}
      blurb={blurb}
    />
  );
};

const TranslatedComponent = withTranslation()(NotFoundPage);

export { TranslatedComponent as NotFoundPage };
